import {useState} from 'react'
import {getClient} from '../services'
import {ClientModel, SelectModel} from '../model'

const useClientListService = () => {
  const [loading, setLoading] = useState(false)
  const [clientList, setClientList] = useState<SelectModel[]>([])
  const getClientService = async (clientParams: ClientModel) => {
    let obj: ClientModel = {
      isCombo: true,
      ...clientParams,
    }
    return await getClient(obj, 1)
  }
  const getClientData = async (clientParams: ClientModel) => {
    setLoading(true)
    try {
      const response = await getClientService(clientParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching client data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }
  const getClientFD = async (clientParams: ClientModel) => {
    setLoading(true)
    try {
      const data = await getClientData(clientParams)
      const mapped = mapClients(data)
      return mapped
    } catch (error) {
      console.error('Error fetching client data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }
  const mapClients = (data: any[]) => {
    return data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
  }

  const updateClientList = (mappedSites: {value: string; label: string}[]) => {
    setClientList(mappedSites)
  }

  const getClientList = async (clientParams: ClientModel = {}) => {
    try {
      const data = await getClientData(clientParams)
      const mappedSites = mapClients(data)
      updateClientList(mappedSites)
    } catch (error) {
      console.error('Error fetching client data:', error)
    }
  }

  const handleClear = () => {
    setClientList([])
  }

  return {
    loading,
    clientList,
    getClientList,
    getClientService,
    getClientFD,
    handleClear,
  }
}

export default useClientListService
